import React from "react"
import { JSX } from "react"
import { Navigate } from "react-router-dom"
import { jwtDecode } from "jwt-decode"
import { API_ROUTES } from "../configuration/RoutesApi"
import { PATH_MAP } from "../configuration/PathMap"

type JwtPayload = {
  exp?: number
  Reseller_Id?: string
}

const ResellerOnlyRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [nowInSeconds] = React.useState(() => Date.now() / 1000)

  const token = localStorage.getItem(API_ROUTES.TOKEN_RESELLER)

  if (!token) {
    return <Navigate to={PATH_MAP.RESELLER_LOGIN_PAGE} replace />
  }

  let canAccessResellerPanel = false

  try {
    const rawToken = token.replace(/['"]/g, "")

    const decoded = jwtDecode<JwtPayload>(rawToken)

    canAccessResellerPanel = Boolean(decoded.exp) && decoded.exp >= nowInSeconds && Boolean(decoded.Reseller_Id)

    if (!canAccessResellerPanel) {
      localStorage.removeItem(API_ROUTES.TOKEN_RESELLER)
    }
  } catch {
    localStorage.removeItem(API_ROUTES.TOKEN_RESELLER)
  }

  return canAccessResellerPanel ? children : <Navigate to={PATH_MAP.RESELLER_LOGIN_PAGE} replace />
}

export default ResellerOnlyRoute
